import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

@Injectable()
export class ParameterService {
    private apiUrl: string;

    constructor(private http: HttpClient, @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal) {
        this.apiUrl = `${ config.apiEndpoint }api/parameters`;
    }

    public getJobReportConfig(): Observable<any> {
        return this.http.get(`${ this.apiUrl }/job-reports`);
    }

    public getHideReportsParameter(): Observable<boolean> {
        return this.http.get<boolean>(`${ this.apiUrl }/hide-reports`);
    }

    public getQuotaPaymentsSandbox(): Observable<boolean> {
        return this.http.get<boolean>(`${ this.apiUrl }/payments-sandbox`);
    }
}
